(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Sort pills: pick the matching radio in the sort control so the existing
  // facets code re-renders the grid in place (no page reload).
  document.addEventListener('click', (event) => {
    const pill = event.target instanceof Element ? event.target.closest('[data-sort-pill]') : null;
    if (!pill) return;

    const value = pill.getAttribute('data-sort-pill');
    const scope = pill.closest('.shopify-section') || document;
    const radios = scope.querySelectorAll('input.sorting-filter__input');
    const radio = Array.from(radios).find((input) => input.value === value);
    if (radio && !radio.checked) radio.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  /* Counts big stat figures up from zero when they scroll into view.

     The target value is read from the rendered text rather than a data
     attribute: these numbers live in `richtext` block settings, and Shopify
     only permits a small set of tags there - a data-* attribute makes the
     whole templates/index.json fail validation and silently stops syncing.

     Selection is therefore content-based: a text block whose entire contents
     are a bare number, set at display size. Prices carry a currency symbol so
     they never match, and anything that doesn't match is simply left alone. */
  function parseStatText(raw) {
    const match = raw.trim().match(/^([\d,]+(?:\.\d+)?)(\D*)$/);
    if (!match) return null;
    const numeric = match[1].replace(/,/g, '');
    const fraction = numeric.split('.')[1];
    return {
      target: parseFloat(numeric),
      decimals: fraction ? fraction.length : 0,
      suffix: match[2] || '',
    };
  }

  function formatStatValue(value, decimals) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  /* Walk to the innermost element that still holds the whole number, so the
     heading/strong wrappers (and their styling) survive the text swap. */
  function innermostTextNode(el) {
    let node = el;
    while (
      node.children.length === 1 &&
      node.firstElementChild.textContent.trim() === node.textContent.trim()
    ) {
      node = node.firstElementChild;
    }
    return node;
  }

  function animateStatCount(el, stat) {
    const duration = 1600;
    const start = performance.now();
    // Update the existing text node in place: replacing textContent every
    // frame is a childList mutation that wakes every page-wide observer.
    const text = el.firstChild && el.firstChild.nodeType === Node.TEXT_NODE ? el.firstChild : null;
    const write = (value) => {
      if (text) text.data = value;
      else el.textContent = value;
    };

    function step(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      write(formatStatValue(stat.target * eased, stat.decimals) + stat.suffix);
      if (progress < 1) requestAnimationFrame(step);
      else write(formatStatValue(stat.target, stat.decimals) + stat.suffix);
    }

    requestAnimationFrame(step);
  }

  function initStatCounters() {
    const blocks = document.querySelectorAll('.text-block:not([data-count-initialized])');
    if (blocks.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    blocks.forEach((block) => {
      const stat = parseStatText(block.textContent);
      if (!stat) return;

      const el = innermostTextNode(block);
      if (parseFloat(window.getComputedStyle(el).fontSize) < 40) return;

      block.setAttribute('data-count-initialized', 'true');
      if (prefersReducedMotion) return;

      el.textContent = formatStatValue(0, stat.decimals) + stat.suffix;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            animateStatCount(el, stat);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatCounters);
  } else {
    initStatCounters();
  }

  document.addEventListener('shopify:section:load', initStatCounters);

  } catch(e) { console.error(e); }
})();
})();
